<template>
  <button
    :class="{
      open: open,
    }"
    @click="$emit('click')"
  >
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="10.5" fill="white" stroke="#DFE4EF" />
      <path
        d="M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z"
        fill="#0066FF"
      />
      <path
        d="M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z"
        fill="#0066FF"
      />
    </svg>
  </button>
</template>

<script>
export default {
  props: ["open"],
};
</script>

<style lang="scss" scoped>
button {
  background: transparent;
  font-size: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  flex-shrink: 0;
  cursor: pointer;

  &,
  &:focus,
  &:hover {
    border: none;
    outline: none;
  }

  svg {
    transform: rotate(180deg);
    transition: transform 250ms ease-in-out;
  }

  &.open {
    svg {
      transform: rotate(0deg);
    }
  }

  &[disabled] {
    opacity: 0.5;
    cursor: default;
  }
}
</style>
